import { Injectable, inject } from '@angular/core';
import { BrowserMetadataService } from '../diagnostic/metadata/browser-metadata.service';
import { UserMetadataService } from '../diagnostic/metadata/user-metadata.service';
import { FeedbackCreateRequest } from '../types/feedback-api.types';
import { FeedbackCategory, FeedbackPriority } from '../types/feedback-payload';
import { RedactionService } from '../security/redaction.service';

export interface FeedbackDraftInput {
  title: string;
  description: string;
  category: FeedbackCategory;
  priority: FeedbackPriority;
}

@Injectable({
  providedIn: 'root',
})
export class FeedbackPayloadBuilderService {
  // This builder intentionally reads browser/user metadata directly. Technical diagnostics uses the same sources,
  // but the feedback payload only needs the redacted route/url and the current employee hint.
  private readonly browserMetadataService = inject(BrowserMetadataService);
  private readonly userMetadataService = inject(UserMetadataService);
  private readonly redactionService = inject(RedactionService);

  buildFeedbackPayload(input: FeedbackDraftInput): FeedbackCreateRequest {
    const browserMetadata = this.browserMetadataService.buildBrowserMetadata();
    const userMetadata = this.userMetadataService.getUserMetadata();

    return {
      title: this.redactionService.redactText(input.title.trim()),
      description: this.redactionService.redactText(input.description.trim()),
      category: input.category,
      priority: input.priority,
      submittedByEmployeeId: userMetadata.submittedByEmployeeId,
      route: browserMetadata.route,
      url: browserMetadata.url,
    };
  }
}
